import { render, staticRenderFns } from "./EmpProviderDetail.vue?vue&type=template&id=3a965cc0&"
import script from "./EmpProviderDetail.vue?vue&type=script&lang=js&"
export * from "./EmpProviderDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports